import { v4 as uuid } from 'uuid';

const SETTINGS_SESSION_HEADER = 'LD-Settings-Session-Id';

let settingsSessionId: string | undefined;

export function createSettingsSessionId() {
  return uuid();
}

export function setSettingsSessionId(id: string) {
  settingsSessionId = id;
}

export function clearSettingsSessionId() {
  settingsSessionId = undefined;
}

export function getSettingsSessionProps(): { settingsSessionId?: string } {
  return settingsSessionId === undefined ? {} : { settingsSessionId };
}

export function getSettingsSessionHeaders(): Record<string, string> {
  return settingsSessionId === undefined ? {} : { [SETTINGS_SESSION_HEADER]: settingsSessionId };
}
